interface Orderable {
    order?: number;
}

const sortArrayWithOrderField = <T extends Orderable>(array: T[] | undefined): T[] => {
    if (!array) return [];

    return [...array].sort((a, b) => {
        const aHasOrder = a.order !== undefined && a.order !== null;
        const bHasOrder = b.order !== undefined && b.order !== null;

        if (!aHasOrder && !bHasOrder) return 0;
        if (!aHasOrder && bHasOrder) return 1;
        if (aHasOrder && !bHasOrder) return -1;

        return (a.order ?? 0) - (b.order ?? 0);
    });
};

const toArray = <T>(value: T | T[] | undefined | null): T[] => {
    if (value == null) return [];
    return Array.isArray(value) ? value : [value];
};

const groupBy = <T, K extends keyof T>(items: T[], key: K): Record<string, T[]> => {
    return items.reduce(
        (rv, x) => {
            const keyValue = String(x[key]);

            rv[keyValue] = rv[keyValue] || [];
            rv[keyValue].push(x);
            return rv;
        },
        {} as Record<string, T[]>
    );
};

const objectToArray = <T>(object: Record<string, T>): {key: string; item: T}[] => {
    return Object.entries(object).map(([k, v]) => {
        return {key: k, item: v};
    });
};

export default {
    sortArrayWithOrderField,
    toArray,
    groupBy,
    objectToArray,
};
